var _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _ellipse, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _line35, _line36, _line37, _line38, _line39, _line40, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmartoctoAiIllustration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1768 615",
    style: {
      enableBackground: "new 0 0 1768 615"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A1A1A;stroke:#1A1A1A;stroke-width:1.7304;stroke-miterlimit:10;}\n\t.st1{fill:#1A1A1A;stroke:#1A1A1A;stroke-width:0.9143;stroke-miterlimit:10;}\n\t.st2{fill:#1A1A1A;stroke:#1A1A1A;stroke-width:1.0686;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.7,
    y1: 375.6,
    x2: 160.4,
    y2: 101.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 160.4,
    y1: 101.4,
    x2: 591.9,
    y2: 20
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 160.4,
    y1: 101.4,
    x2: 456.6,
    y2: 199.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 591.9,
    y1: 20,
    x2: 456.6,
    y2: 199.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 741.1,
    y1: 89.3,
    x2: 456.6,
    y2: 199.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 207.5,
    y1: 555.1,
    x2: 415.9,
    y2: 458.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 207.5,
    y1: 555.1,
    x2: 20.7,
    y2: 375.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 207.5,
    y1: 555.1,
    x2: 595.5,
    y2: 596.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 431.9,
    y1: 452.7,
    x2: 595.5,
    y2: 596.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 595.5,
    y1: 596.2,
    x2: 1025.4,
    y2: 455.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 751,
    y1: 295.9,
    x2: 816,
    y2: 167.8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 817.2,
    y1: 163,
    x2: 741.1,
    y2: 89.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1025.4,
    y1: 455.6,
    x2: 1185.1,
    y2: 365.1
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1266.7,
    y1: 60.4,
    x2: 1182.4,
    y2: 365.3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1449.8,
    y1: 248.6,
    x2: 1523.2,
    y2: 550.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1038.3,
    y1: 596.5,
    x2: 1025.4,
    y2: 455.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 723.8,
    y1: 465.8,
    x2: 207.5,
    y2: 555.1
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 727.8,
    y1: 462.9,
    x2: 1025.4,
    y2: 455.6
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1266.7,
    y1: 60.4,
    x2: 1497.2,
    y2: 62.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 591.9,
    y1: 20,
    x2: 741.1,
    y2: 89.3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1266.7,
    y1: 60.4,
    x2: 1091.4,
    y2: 216.4
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1038.3,
    y1: 596.5,
    x2: 1523.2,
    y2: 550.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1572.7,
    y1: 192.7,
    x2: 1497.3,
    y2: 60.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 591.9,
    y1: 20,
    x2: 747.4,
    y2: 300
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 727.8,
    y1: 462.9,
    x2: 748.5,
    y2: 297.4
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1449.8,
    y1: 248.6,
    x2: 1266.7,
    y2: 60.4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1748.5,
    y1: 305.1,
    x2: 1523.2,
    y2: 550.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1748.5,
    y1: 305.1,
    x2: 1572.7,
    y2: 192.7
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 817.2,
    y1: 163,
    x2: 1038.2,
    y2: 33.8
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1523.2,
    y1: 550.2,
    x2: 1038.2,
    y2: 33.8
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1644.8,
    y1: 294.1,
    x2: 1748.5,
    y2: 305.1
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1025.4,
    y1: 455.6,
    x2: 1523.2,
    y2: 550.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1159.6,
    y1: 525.9,
    x2: 1449.8,
    y2: 248.6
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1642.8,
    y1: 292.7,
    x2: 1266.7,
    y2: 60.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 591.9,
    cy: 20,
    r: 13
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 456.6,
    cy: 199.7,
    r: 13
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 741.1,
    cy: 89.3,
    r: 13
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 817.2,
    cy: 163,
    r: 13
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1038.2,
    cy: 33.8,
    r: 13
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1266.7,
    cy: 60.4,
    r: 13
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1497.3,
    cy: 60.2,
    r: 13
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1572.7,
    cy: 192.7,
    rx: 14.8,
    ry: 15.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1748.5,
    cy: 305.1,
    r: 13
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1523.2,
    cy: 550.2,
    r: 13
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1025.4,
    cy: 455.6,
    r: 13
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 727.8,
    cy: 462.9,
    r: 13
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1038.3,
    cy: 596.5,
    r: 13
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 595.5,
    cy: 596.2,
    r: 13
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.2,
    cy: 453.1,
    r: 13
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 207.5,
    cy: 555.1,
    r: 13
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20.7,
    cy: 375.6,
    r: 13
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 157.2,
    cy: 102.3,
    r: 13
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1159.6,
    cy: 525.9,
    r: 13
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1642.8,
    cy: 292.7,
    r: 13
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 157.2,
    y1: 102.3,
    x2: 260.6,
    y2: 314.8
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 429.2,
    y1: 453.1,
    x2: 454.5,
    y2: 202.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 730.1,
    y1: 464.9,
    x2: 1038.2,
    y2: 33.8
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 595,
    y1: 598.3,
    x2: 1159.4,
    y2: 526.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 727.8,
    y1: 462.9,
    x2: 1038.3,
    y2: 596.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 458.5,
    y1: 197.8,
    x2: 260.6,
    y2: 314.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 748.5,
    cy: 297.4,
    r: 13
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.6,
    cy: 314.8,
    r: 13
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1182.4,
    cy: 365.3,
    r: 13
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1091.4,
    cy: 216.4,
    r: 13
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 926,
    cy: 367.1,
    r: 13
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 589.6,
    cy: 277.1,
    r: 13
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1449.8,
    cy: 248.6,
    r: 13
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1038.2,
    y1: 33.8,
    x2: 1091.4,
    y2: 216.4
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1091.4,
    y1: 216.4,
    x2: 1025.4,
    y2: 455.6
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 817.2,
    y1: 163,
    x2: 927.2,
    y2: 370.7
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 747.4,
    y1: 300,
    x2: 590.4,
    y2: 274.9
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 431.9,
    y1: 452.7,
    x2: 589.6,
    y2: 277.1
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1091.4,
    y1: 216.4,
    x2: 927.2,
    y2: 370.7
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 260.6,
    y1: 314.8,
    x2: 429.2,
    y2: 453.1
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1497.3,
    y1: 60.2,
    x2: 1449.8,
    y2: 248.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmartoctoAiIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smartocto_ai_illustration.74aa3700580b03247d783f746542aed7.svg";